// extracted by mini-css-extract-plugin
export var icon = "_aw-3";
export var subtitle = "_aw-2";
export var title = "_aw-1";
export var value = "_aw-0";